/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

import * as overrides from '../../operation-overrides/getProjectSdkKeysOverrides';
import type { GetProjectSdkKeysQueryParams } from '../../operation-overrides/getProjectSdkKeysOverrides';

export type GetProjectSdkKeysPathParams = NonNullable<operations['getProjectSdkKeys']['parameters']['path']>;
export type { GetProjectSdkKeysQueryParams };

export interface Input extends GetProjectSdkKeysPathParams {
  apiVersion?: string;
  query?: GetProjectSdkKeysQueryParams;
  header: NonNullable<operations['getProjectSdkKeys']['parameters']['header']>;
}

export async function getProjectSdkKeys(
  { apiVersion, query, header, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/projects/{projectKey}/sdk-keys', {
    params: {
      path,
      // @ts-ignore We explicitly ignore errors here because we know the types may not match the spec
      query,
      header,
    },
    // @ts-ignore We explicitly ignore errors here because we know the types may not match the spec
    querySerializer: overrides.querySerializer,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
